import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthenticationService } from '../services';
import { map, take } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class AuthLoginGuard  {
    constructor(
        private authenticationService: AuthenticationService,
    ) { }

    canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.authenticationService.checkUserAlreadyValidLogin().pipe(
            take(1),
            map((valid: boolean) => {
                if (valid) {
                    this.authenticationService.navigateToMainPage();
                }
                return !valid;
            })
        )
    }

}
